import { Button, Card, Col, Form, message, Row, Select } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import { getAvailableVdGroups, saveAutoLoginVd } from '../../services/mgmt';
import { getErrorFields } from '../utils';
import { UserInfo } from './components';
import ThemeContext from '../../store/ThemeContext';

function MyInfo() {
  const [availableVdGroups, setAvailableVdGroups] = useState([]);
  const theme = useContext(ThemeContext);

  const [form] = Form.useForm();

  useEffect(async () => {
    if (theme?.autoConnect) {
      const res = await getAvailableVdGroups();
      if (res.data.length > 0) {
        let vd = res.data?.[0].id;
        res.data.forEach((d) => {
          if (d.autoLogin === true) {
            vd = d.id;
          }
        });
        form.setFieldsValue({ ...form.getFieldsValue(), vdGroupId: vd });
      }
      setAvailableVdGroups(res.data);
    }
  }, []);
  return (
    <Row gutter={[16, 40]}>
      <Col span={24}>
        <UserInfo />
      </Col>
      {theme?.autoConnect && (
        <Col span={24}>
          <Card title="환경 설정">
            <Form
              form={form}
              layout="horizontal"
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
              onFinish={async ({ ...fields }) => {
                const payload = fields;
                const res = await saveAutoLoginVd(payload);
                if (res.status === 'error') {
                  const items = res.data.invalidParams;
                  const error = getErrorFields(items);
                  form.setFields(error);
                  message.error('저장실패');
                } else {
                  message.success('저장성공');
                }
              }}
            >
              <Form.Item label="자동 접속" name="vdGroupId">
                <Select
                  style={{ width: 400 }}
                  placeholder="자동 접속할 VD를 선택하여 주십시오"
                  options={availableVdGroups.map((v) => ({
                    label: v.vdName ? `${v.vdGroupName}/${v.vdName}` : v.vdGroupName,
                    value: v.id,
                  }))}
                />
              </Form.Item>
              <Form.Item label={null} wrapperCol={{ offset: 2 }}>
                <Button type="primary" htmlType="submit">
                  저장
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      )}

      {/* <Col span={24}>
          <div style={{ padding: 8 }}>
            <strong>사용 현황</strong>
          </div>
          <Collapse accordion>
            <Collapse.Panel header="Desktops 현황">
              <UsageDesktop />
            </Collapse.Panel>
            <Collapse.Panel header="Disk 현황">
              <UsageDisk />
            </Collapse.Panel>
          </Collapse>
        </Col>
        <Col span={24}>
          <div style={{ padding: 8 }}>
            <strong>결재 관리</strong>
          </div>
          <ApprovalManagement />
        </Col> */}
    </Row>
  );
}

export default MyInfo;
